"use strict";
/**
 * Wire format for the admin-editor preview inspector. The admin frame drives
 * the mode (`INSPECT_SET_MODE`), the shopper frame emits picks and exit
 * signals. Envelopes are validated by the `type` discriminator on the
 * receiving side.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSPECT_MESSAGE_TYPE = void 0;
exports.INSPECT_MESSAGE_TYPE = {
    /** Parent → iframe. Enter or leave inspect mode. */
    SET_MODE: 'inspect-set-mode',
    /** Iframe → parent. User clicked a candidate element. */
    SELECTION: 'inspect-selection',
    /** Iframe → parent. User pressed Escape inside the iframe. */
    EXIT: 'inspect-exit',
    /** Parent → iframe. Check whether a cropped HTML-section image fits its box. */
    MEASURE_IMAGE: 'inspect-measure-image',
    /** Iframe → parent. Answer to MEASURE_IMAGE. */
    IMAGE_MEASURED: 'inspect-image-measured',
};
